package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ChatContentModel(
    val text: String,
    val files: MutableList<ChatLinkMessagesModel>,
    @SerialName("expert_mode")
    val expertMode: ChatExpertModeModel? = null
)
